module.exports = __webpack_public_path__ + "media/images/sogodyLogo-19e16d05d6285b109839f06e5974456c.png";